<template>
  <v-text-field
    style="width:200px"
    :v-model="modelName"
    :label="numberLabel"
    :value="value"
    type="number"
    min=0
    :step="step"
    outlined
    :rules="[rules.numeric, rules.min_value(value,modelName,total,hanigoTotal), rules.max_value(value, modelName, total)]"
    :disabled="isDisabled"
    color="secondary"
    dense
    @input="onInputNumber"
  >
    <template v-slot:prepend  v-if="$slots.prepend">
      <slot name="prepend"/>
    </template>
  </v-text-field>
</template>

<script>
export default {
  components: {
  },

  props: {
    numberLabel: {
      type: String,
      default: '',
    },
    modelName: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String],
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    hanigoTotal: {
      type: Number,
      default: 0,
    }
  },

  data: () => ({
    rules: {
      numeric: value => {
        let result = true
        if ((value !== '0' && value !== 0) && !value) result = '数字のみで入力してください'
        return result
      },
      min_value: function(value, mode, total, hanigoTotal) {
        let result = true
        if(mode==='hani' && hanigoTotal < 5)                      result = '反意語の最低設問数５問に満たないためテストを作成できません'
        if((mode==='hani' || mode==='other') && total < 10) result = '最低設問数10問に満たないためテストを作成できません。'
        return result
      },
      max_value: function(value, mode, total) {
        let result = true
        if(total > 200) result = '設問数はトータル200問以内になるように入力してください'
        return result
      },
    },
  }),

  methods: {
    onInputNumber(value) {
      //入力されたvalueを親に送り、storeにsetする(処理typeで分けたいので親側で処理する)
      if (value) value = Number(value)
      this.$emit('setNumber', value)
    }
  },

  computed: {
    step() {
      return (this.modelName==='hani' || this.modelName==='other') && !this.value ? 10 : 1
    }
  }
}
</script>

<style lang="stylus" scoped>
  .field
    display inline-block
    margin-left 20px
</style>
